import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDDialog, FDDialogActions,
  FDDialogContent,
  FDDialogTitle,
  FDPrimaryActionButton,
  FDSecondaryActionButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export function DocumentTypeEditorLayout({
  open,
  onClose,
  handleUpdate,
}) {
  const { resource } = useMetaLayoutContext();
  const [loading, setLoading] = useState(false);
  // If this gets re-used by react, ensure to reset the loading status
  useEffect(() => {
    setLoading(false);
  }, [resource.id()]);
  return (
    <FDDialog
      open={open}
      onClose={onClose}
    >
      <FDDialogTitle value="Choose document type" />
      <FDDialogContent>
        <MetaControlField attr="documentTypeForML" />
      </FDDialogContent>
      <FDDialogActions>
        <FDSecondaryActionButton
          onClick={onClose}
          label="Cancel"
        />
        <FDPrimaryActionButton
          loading={loading}
          onClick={() => {
            setLoading(true);
            handleUpdate({ documentTypeForML: resource.attr('documentTypeForML') }).finally(() => setLoading(false));
          }}
          label="Save"
        />
      </FDDialogActions>
    </FDDialog>
  );
}

DocumentTypeEditorLayout.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
};
